export const CriteriaChecker = (num: number) => {
  if (num >= 0 && num <= 5) {
    return "Up to 5 kgs";
  } else if (num <= 10) {
    return "5 to 10 kg";
  } else if (num <= 15) {
    return "10 to 15 kg";
  } else if (num <= 20) {
    return "15 to 20 kg";
  } else {
    return "20 kg above";
  }
};
